<template>
  <div class="color-sample n2-east">
    <section class="adjust-top">
      <p class="small-text">
        享年 八十八歳
      </p>
    </section>
    <section class="flex center grow adjust-top">
      <div class="box">
        <p class="small-text">
          俗名
        </p>
      </div>
      <div class="box flex center grow column">
        <p class="box default-text">
          源頼朝
        </p>
        <p class="box default-text">
          源頼朝
        </p>
      </div>
      <div class="box grow" />
    </section>
    <section class="adjust-top">
      <p class="small-text">
        享年 八十八歳
      </p>
    </section>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
  },
  mounted () {},
  data () {
    return {
    };
  },
  computed: {
  },
  watch: {},
  destroyed () {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";
@import "~@/assets/styles/tablet-back.scss";
</style>
